import styled from 'styled-components';
import { pickThemeFontStyles } from '@/theme';

export const StyledModalTitle = styled.div`
  ${pickThemeFontStyles('20', '24', 'SEMI_BOLD')};
`;

export const StyledModalButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;

  &&& {
    button {
      width: 100%;
    }
  }
`;

export const StyledModalDescription = styled.div`
  ${pickThemeFontStyles('14', '22')};
`;

export const StyledModalContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
